import {
  buildSensorsPayloadFromRows,
  type SensorFormRow,
  type SensorPayloadItem,
  type SensorSelectRow,
} from './sensorFormPayload';

const MANY_SENSORS = 20;

/** The edit save's sensor part: `sensors` to send (absent when nothing may be sent), a warning to show, or why the save can't go ahead. */
export type EditSensorsPayload =
  | { ok: true; sensors?: SensorPayloadItem[]; warning?: string }
  | { ok: false; message: string };

/** Builds the edit save's `sensors`, leaving them out when the company has no sensor credentials, because sending `[]` archives every sensor (spec UE6). */
export function editSensorsPayload({
  rows,
  sensorsList,
  includeProductIds,
  sensorRequired,
}: {
  rows: SensorFormRow[] | undefined;
  sensorsList: SensorSelectRow[];
  includeProductIds: boolean;
  sensorRequired: boolean;
}): EditSensorsPayload {
  if (sensorsList.length === 0) return { ok: true };
  const built = buildSensorsPayloadFromRows(rows, sensorsList, {
    includeProductIds,
  });
  if (built.ok === false) return { ok: false, message: built.message };
  if (sensorRequired && built.sensors.length === 0) {
    return { ok: false, message: 'Please enter sensor id' };
  }
  return {
    ok: true,
    sensors: built.sensors,
    warning:
      built.sensors.length > MANY_SENSORS
        ? 'You added more than 20 sensors. Please confirm all IDs are correct before saving.'
        : undefined,
  };
}
